import { MaterialAutocomplete, TextField } from 'form';
import { useTranslation } from 'i18n';
import { Grid, Typography } from 'ui';

export const MaterialSection = () => {
  const { t } = useTranslation('orders');

  return (
    <>
      <Typography variant="h5">{t('profitabilityCalculator.material.title')}</Typography>
      <Grid container spacing={3}>
        <Grid
          size={{
            md: 6,
            xs: 12,
          }}
        >
          <TextField label={t('profitabilityCalculator.material.labels.tonnes')} type="number" name="tonnes" required />
        </Grid>
        <Grid
          size={{
            md: 6,
            xs: 12,
          }}
        >
          <TextField
            label={t('profitabilityCalculator.material.labels.tonnesPerLoad')}
            type="number"
            required
            name="tonnes_per_load"
          />
        </Grid>
        <Grid
          size={{
            md: 6,
            xs: 12,
          }}
        >
          <MaterialAutocomplete
            label={t('profitabilityCalculator.material.labels.material')}
            name="material"
            required
          />
        </Grid>
      </Grid>
    </>
  );
};
